
import { Movie } from "@/types/movie";

/**
 * Convert Movie object to user_movies table payload
 * Only includes fields that exist in the user_movies table
 */
export function toUserMoviesPayload(movie: Movie): any {
  return {
    tmdb_id: movie.tmdbId,
    title: movie.title || 'Unknown Title',
    director: movie.director || 'Unknown Director',
    year: movie.year || 0,
    tags: movie.tags || [],
    favorite: movie.favorite || false,
    plan_to_watch: movie.planToWatch || false,
    poster_path: movie.posterPath,
    backdrop_path: movie.backdropPath,
    overview: movie.overview,
    poster: movie.posterPath // Legacy field for compatibility
  };
}

/**
 * Convert Movie object to RPC payload with all metadata fields
 * UPDATED: Enhanced to include all metadata fields for future-proofing
 */
export function toRpcPayload(movie: Movie): any {
  return {
    tmdb_id: movie.tmdbId,
    title: movie.title || 'Unknown Title',
    director: movie.director || 'Unknown Director',
    year: movie.year || 0,
    tags: movie.tags || [],
    favorite: movie.favorite || false,
    plan_to_watch: movie.planToWatch || false,
    poster_path: movie.posterPath,
    backdrop_path: movie.backdropPath,
    overview: movie.overview,
    // Enhanced metadata fields for future-proofing
    release_date: movie.releaseDate,
    vote_average: movie.voteAverage,
    runtime: movie.runtime,
    popularity: movie.popularity,
    genres: movie.genres || []
  };
}
